import { call, put, takeEvery } from 'redux-saga/effects';
import { updateLeadsAffiliate } from '../../requests/update_affiliate_request';
import { updateAffiliateRequestSuccess, updateAffiliateRequestFailure } from '../actions/update_affiliate.actions';
import { UPDATE_AFFILIATE_REQUEST } from '../constants/update_affiliate.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* updateAffiliatesSagaRequest({ payload: { id, name, value } }) {
    const { result, options, error } = yield call(updateLeadsAffiliate, id, name, value);

    if (result) {
        yield put(updateAffiliateRequestSuccess(options));
        message_success(`${options.name} affiliate changed successfully!`);
    } else {
        yield put(updateAffiliateRequestFailure(error));
        if (error.name === 'DocumentAlreadyExistsError') {
            message_error('Affiliate already exist with this old crm affiliate id');
        }
    }
}

export default function* updateAffiliatesSaga() {
    yield takeEvery(UPDATE_AFFILIATE_REQUEST, updateAffiliatesSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_update/redux/sagas/update_affiliate.saga.js